module.exports = __webpack_public_path__ + "img/contact.768eb043.svg";